import React from "react";
import { Link } from "react-router-dom";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaInstagram,
  FaWhatsapp,
  FaHeart,
  FaCalendarAlt,
} from "react-icons/fa";
import { FaGoogle } from "react-icons/fa6";
import { useSelector } from "react-redux";

const Footer = () => {
  const hotel = useSelector((state) => state.hotel.data);

  const contact = hotel?.contact || {
    footerName: "Ganesh Holiday Homes",
    phone: "+91 9673150591",
    altPhone: "+91 9028139260",
    email: "ganeshholidayhomes@gmail.com",
    website: "www.ganeshholidayhomes.com",
    address: "Narayan Pakhadi Rd, Narayan Pakhadi, Shrivardhan-402110, Maharashtra, India",
    instagramProfile: "https://www.instagram.com/ganesh_holiday_homes",
    googleReview: "https://g.page/r/CYDCxgRHSYI9EBM/review",
  };

  const cleanPhone = (contact.phone || "+91 9673150591").replace(/[^0-9]/g, "");

  return (
    <footer
      style={{
        backgroundColor: "#07101e",
        color: "#94a3b8",
        borderTop: "1px solid rgba(255, 255, 255, 0.08)",
        marginTop: "auto",
      }}
      className="pt-5 pb-3"
    >
      <div className="container">
        <div className="row g-4 mb-4 text-start">
          {/* Column 1: Brand Info */}
          <div className="col-12 col-md-6 col-lg-4">
            <h5 className="fw-bold text-white mb-2 font-heading" style={{ fontSize: "1.4rem" }}>
              {contact.footerName || "Ganesh Holiday Homes"}
            </h5>
            <div className="badge bg-danger bg-opacity-75 text-white mb-2 small">
              Short-Term Accommodation Property
            </div>
            <p className="small mb-3 text-secondary" style={{ lineHeight: "1.6" }}>
              Experience authentic Konkani warmth, serene short-term room stays, and mouth-watering homemade seafood & vegetarian cuisine just 5 minutes from Shrivardhan Beach.
            </p>
            <div className="d-flex align-items-center gap-2">
              {contact.instagramProfile && (
                <a
                  href={contact.instagramProfile}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-sm btn-outline-light rounded-circle p-2 d-flex align-items-center justify-content-center"
                  style={{ width: "36px", height: "36px" }}
                  aria-label="Instagram"
                >
                  <FaInstagram />
                </a>
              )}
              {contact.googleReview && (
                <a
                  href={contact.googleReview}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-sm btn-outline-light rounded-circle p-2 d-flex align-items-center justify-content-center"
                  style={{ width: "36px", height: "36px" }}
                  aria-label="Google Review"
                >
                  <FaGoogle />
                </a>
              )}
              <a
                href={`https://wa.me/${cleanPhone}`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-sm btn-outline-success rounded-circle p-2 d-flex align-items-center justify-content-center"
                style={{ width: "36px", height: "36px" }}
                aria-label="WhatsApp"
              >
                <FaWhatsapp />
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="col-6 col-md-6 col-lg-2">
            <h6 className="fw-bold text-white mb-3 text-uppercase small tracking-wider">
              Explore Stay
            </h6>
            <ul className="list-unstyled small d-flex flex-column gap-2 mb-0">
              <li>
                <Link to="/" className="text-secondary text-decoration-none hover-white">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/rooms" className="text-secondary text-decoration-none hover-white">
                  Our Rooms & Tariffs
                </Link>
              </li>
              <li>
                <Link to="/about-us" className="text-secondary text-decoration-none hover-white">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact-us" className="text-secondary text-decoration-none hover-white">
                  Contact & Location
                </Link>
              </li>
              <li>
                <Link to="/booking" className="text-secondary text-decoration-none hover-white">
                  Book Your Stay
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Legal & Support */}
          <div className="col-6 col-md-6 col-lg-3">
            <h6 className="fw-bold text-white mb-3 text-uppercase small tracking-wider">
              Compliance & Policies
            </h6>
            <ul className="list-unstyled small d-flex flex-column gap-2 mb-0">
              <li>
                <Link to="/terms-and-conditions" className="text-secondary text-decoration-none hover-white">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-secondary text-decoration-none hover-white">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/cancellation-refund-policy" className="text-secondary text-decoration-none hover-white">
                  Cancellation & Refund Policy
                </Link>
              </li>
              <li>
                <Link to="/contact-us" className="text-secondary text-decoration-none hover-white">
                  Customer Support
                </Link>
              </li>
              <li>
                <a
                  href={contact.googleReview || "#"}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-secondary text-decoration-none hover-white"
                >
                  Guest Reviews (Google)
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact & Location */}
          <div className="col-12 col-md-6 col-lg-3">
            <h6 className="fw-bold text-white mb-3 text-uppercase small tracking-wider">
              Location & Contact
            </h6>
            <ul className="list-unstyled small d-flex flex-column gap-2 mb-0">
              <li className="d-flex align-items-start gap-2">
                <FaMapMarkerAlt className="text-danger mt-1 flex-shrink-0" />
                <span>{contact.address}</span>
              </li>
              <li className="d-flex align-items-center gap-2">
                <FaPhoneAlt className="text-danger flex-shrink-0" />
                <a href={`tel:${cleanPhone}`} className="text-light text-decoration-none">
                  {contact.phone} {contact.altPhone && ` / ${contact.altPhone}`}
                </a>
              </li>
              <li className="d-flex align-items-center gap-2">
                <FaEnvelope className="text-danger flex-shrink-0" />
                <a href={`mailto:${contact.email}`} className="text-light text-decoration-none">
                  {contact.email}
                </a>
              </li>
            </ul>
            <div className="mt-3">
              <Link to="/booking" className="btn btn-sm btn-outline-warning rounded-pill px-3 py-1">
                <FaCalendarAlt className="me-1" /> Reserve Room Online
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div
          className="border-top pt-3 mt-4 text-center small text-secondary d-flex flex-column flex-md-row justify-content-between align-items-center gap-2"
          style={{ borderColor: "rgba(255, 255, 255, 0.08)" }}
        >
          <div>
            © {new Date().getFullYear()} <span className="text-white fw-semibold">{contact.footerName || "Ganesh Holiday Homes"}</span>. All rights reserved.
          </div>
          <div className="d-flex align-items-center justify-content-center gap-1 text-secondary">
            Crafted with <FaHeart className="text-danger mx-1" style={{ fontSize: "0.85rem" }} /> by <span className="text-info ms-1 fw-semibold">Tejas Patil</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
